import React, {useState, useEffect} from "react";
import { Modal, ModalBody, Button, ButtonToolbar, ModalHeader } from 'reactstrap';
import axios from 'axios'
import {renameChildrenToSubrows} from '@/shared/helpers'
import {useDispatch, sendFlashMessage} from "@/shared/components/flash";
import ProgramTreeView from "../../components/ProgramTreeView";
import {fetchProgramTreeForMoving} from "@/shared/apiHelper"

const MoveSubProgramModal = ({isOpen, setOpen, toggle, subprogram, organization, setTrigger}) => {
    const dispatch = useDispatch()
    const [formError, setFormError] = useState('');
    const [loading, setLoading] = useState(false);
    const [disableMove, setDisableMove] = useState(false);
    const [selected, setSelected] = useState(null);
    const [expanded, setExpanded] = useState(null);
    const [exclude, setExclude] = useState([]);
    let [data, setData] = useState(null);
    const [originalSelected, setOriginalSelected] = useState([]);

    useEffect( () => {
        if( subprogram?.id )  {
            setSelected(subprogram.id)
            setOriginalSelected(subprogram.id)
            fetchProgramTreeForMoving(subprogram.organization_id, subprogram.id)
            .then( response => {
                setData(renameChildrenToSubrows([response.tree]));
                setExclude(response.exclude);
            })
        }
    }, [subprogram])

    const handleSelect = (event, nodeIds) => {
        setFormError('');
        setDisableMove(false);
        if( typeof exclude === 'object' && exclude.length > 0 && nodeIds)  {
            if(exclude.indexOf(nodeIds) !== -1)  {
                setDisableMove(true);
                setFormError('cannot select to this node');
                return;
            }
        }
        setSelected(nodeIds)
    };
    const onClickMoveConfrim = async() => {
        setLoading(true)
        if( selected.length <=0 ) setFormError('Select a program to move to');
        else if( selected === subprogram.id )  setFormError('Select a different program to move to');
        else   {
            try {
                let formData = {
                    parent_id: selected === 'allprograms' ? null : selected
                }
                setLoading( true )
                const response = await axios.patch(`/organization/${subprogram.organization_id}/program/${subprogram.id}/move`, formData);
                setLoading(false)
                if( response.status === 200)    {
                    setOpen(false)
                    dispatch(sendFlashMessage('SubProgram has been moved', 'alert-success', 'top'))
                    setTrigger( Math.floor(Date.now() / 1000) )
                }
            } catch (e) {
                setLoading(false)
                dispatch(sendFlashMessage('Program could not be moved', 'alert-danger', 'top'))
                throw new Error(`API error:${e?.message}`);
            }
        }
        setLoading(false)
    };

    if( !organization || !subprogram || !data ) return 'Loading...'

    return (
        <Modal className="modal-program manager-program-modal modal-md" isOpen={isOpen} toggle={toggle}>
            <ModalHeader tag="div" className="manager-program-modal__header">
                <div className="manager-program-modal__header-row">
                    <div className="manager-program-modal__header-copy">
                        <h3 className="manager-program-modal__title">Move Subprogram</h3>
                        <p className="manager-program-modal__subtitle">
                            Choose a new parent location for {subprogram.name}.
                        </p>
                    </div>
                    <ButtonToolbar className="manager-program-modal__actions">
                        <Button outline color="primary" onClick={toggle}>Close</Button>
                    </ButtonToolbar>
                </div>
            </ModalHeader>
            <ModalBody className="manager-program-modal__body" style={{maxHeight:'600px'}}>
                <div className="manager-program-modal__form-head">
                    <h4 className="manager-program-modal__form-title">Destination Program</h4>
                    <p className="manager-program-modal__form-copy">
                        Select the destination node from the hierarchy below.
                    </p>
                </div>
                <ProgramTreeView data={data} handleSelect={handleSelect} selected={selected} rootNode={false} expandedList={expanded} />
                {formError && <span className="form__form-group-error">{formError}</span>}
                <div className="manager-program-modal__footer-actions">
                    <Button type="submit" disabled={selected===originalSelected || loading || disableMove} className="btn btn-primary" color="#ffffff" onClick={onClickMoveConfrim}>
                        Confirm Move
                    </Button>
                </div>
            </ModalBody>
        </Modal>
    )
}

export default MoveSubProgramModal
